import ProductManagementModule from "@/modules/SiteProductManagement";

function ProductManagementPage() {
  return <ProductManagementModule />;
}

export default ProductManagementPage;
